import React from 'react'
import { DcButton } from 'pixel-base'
import { FinanceActionItem } from '../types'

interface Props {
  actions: FinanceActionItem[]
}

const variantMap = {
  primary: 'outline-primary',
  secondary: 'outline-secondary',
  success: 'outline-success',
  warning: 'outline-warning',
  danger: 'outline-danger',
} as const

const FinanceListActions: React.FC<Props> = ({ actions }) => (
  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
    {actions
      .filter((item) => !item.hidden)
      .map((item) => (
        <DcButton
          key={item.key}
          size="sm"
          variant={variantMap[item.tone || 'secondary']}
          disabled={item.disabled}
          onClick={item.onClick}
        >
          {item.label}
        </DcButton>
      ))}
  </div>
)

export default FinanceListActions
